import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IReminder } from '../models/models'

export class PostDealerReminderApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'payment/get-dealer-reminder',
      requesterInfo,
    })
  }

  public async postDealerReminder(): Promise<IReminder[]> {
    return await this.postAsync<IReminder[]>()
  }
}
